import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Overline } from "@/components/Reveal";

const BOWL = "https://images.pexels.com/photos/9832652/pexels-photo-9832652.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export default function SeeTheCrunch() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.35, 1.1, 1.35]);
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section ref={ref} className="relative h-[90svh] overflow-hidden bg-black" data-testid="see-the-crunch-section">
      <motion.div style={{ scale, y }} className="absolute inset-0">
        <img src={BOWL} alt="Macro close-up of crunchy Dignity nachos with spices" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/60" />

      {/* floating spice particles */}
      {["🌶", "🍅", "🥬", "🧄", "🌿", "🔥"].map((p, i) => (
        <motion.span key={i}
          className="absolute text-2xl opacity-70"
          style={{ left: `${10 + i * 15}%`, top: `${20 + (i % 3) * 20}%` }}
          animate={{ y: [0, -30, 0], rotate: [0, 15, -15, 0], opacity: [0.3, 0.8, 0.3] }}
          transition={{ duration: 5 + i, repeat: Infinity, ease: "easeInOut" }}>
          {p}
        </motion.span>
      ))}

      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col items-center justify-center px-5 text-center">
        <Overline>Look Closer</Overline>
        <motion.h2
          initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }} transition={{ duration: 0.9 }}
          className="mt-4 font-display text-[18vw] leading-none tracking-tight text-cream lg:text-[12vw]">
          SEE THE <span className="text-gold-gradient">CRUNCH.</span>
        </motion.h2>
        <p className="mt-6 max-w-xl text-white/60">
          Real texture. Real spice. Every triangle baked then lightly fried for that
          unmistakable Dignity snap.
        </p>
      </div>
    </section>
  );
}
